import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/eap")({
  pendingComponent: PagePending,});
